import { useMutation } from '@tanstack/react-query';
import { userService } from '../../../services/UserService';
import type { UpdateCurrentUserPasswordInput } from '../../../types/user';

export function useUpdateCurrentUserPasswordMutation() {
  return useMutation({
    mutationFn: (input: UpdateCurrentUserPasswordInput) =>
      userService.updateCurrentUserPassword(
        input.currentPassword,
        input.newPassword,
      ),
  });
}
